export const embeddedFunToolRoutes: Record<string, string> = {
  shengbei: '/shengbei?embed=experience',
  lingbai: '/lingbai?embed=experience',
  zhanxingtouzi: '/astro-dice?embed=experience',
  guaqian: '/guaqian?embed=experience',
  shengxiaopeidui: '/zodiac-detail?embed=experience&tab=pairTest',
  meihuayishu: '/zhouyi-detail?embed=experience&tab=meihua',
  liuyaogigua: '/liuyao?embed=experience',
  shicaogigua: '/shicao?embed=experience',
};

export const AVAILABLE_FUN_TOOL_IDS = ['shengbei', 'guaqian'];

export function isAvailableFunTool(toolId: string): boolean {
  return AVAILABLE_FUN_TOOL_IDS.includes(toolId);
}

const EXPERIENCE_MODULE_IDS = new Set([
  'bazi',
  'zodiac',
  'tarot',
  'shengxiao',
  'ziwei',
  'fun',
]);

export function experienceModulePath(id: string): string {
  return EXPERIENCE_MODULE_IDS.has(id) ? `/experience/${id}` : '/experience/bazi';
}

export function experienceFunToolPath(toolId: string): string {
  return `/experience/fun/${toolId}`;
}

export function resolveLegacyExperiencePath(search: string): string {
  const params = new URLSearchParams(search);
  const tool = params.get('tool');
  const sub = params.get('sub');

  if (tool === 'fun') {
    return sub && isAvailableFunTool(sub)
      ? experienceFunToolPath(sub)
      : experienceModulePath(tool);
  }
  if (tool) {
    return experienceModulePath(tool);
  }
  return '/experience/bazi';
}

export function withBasePath(path: string): string {
  const base = __BASE_PATH__ || '/';
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;
  return `${normalizedBase}${path}`;
}
